function randBetween(min, max, decimals) {
    decimals = decimals || false;

    if (decimals) {
        return Math.random() * (max - min);
    } else {
        return Math.floor(Math.random() * (max - min)) + min;
    }
}

function isMobileDevice() {
    if ($("html").hasClass("ua-ios") || $("html").hasClass("ua-android")) {
        return true;
    }

    return false;
}